module.exports = __webpack_public_path__ + "static/media/new-logo.e543e129.svg";